var TypeaheadActionType;
(function (TypeaheadActionType) {
    TypeaheadActionType["Suggestions"] = "Suggestions";
    TypeaheadActionType["Selected"] = "Selected";
    TypeaheadActionType["Error"] = "Error";
    TypeaheadActionType["Reset"] = "Reset";
})(TypeaheadActionType || (TypeaheadActionType = {}));
const defaultSuggestion = {
    id: null,
    title: '',
    subTitle: '',
    highlighted: false,
};
function createDefaultTypeaheadReducerState({ suggestions, }) {
    return {
        suggestions,
        selectedSuggestion: defaultSuggestion,
    };
}
function typeaheadReducer(state, action) {
    switch (action.type) {
        case TypeaheadActionType.Suggestions: {
            return {
                ...state,
                suggestions: action.suggestions,
            };
        }
        case TypeaheadActionType.Selected: {
            return {
                ...state,
                selectedSuggestion: action.selectedSuggestion,
            };
        }
        case TypeaheadActionType.Reset: {
            return {
                ...createDefaultTypeaheadReducerState({ suggestions: [] }),
            };
        }
        default: {
            throw new Error(`Unhandled action type: ${String(action.type)}`);
        }
    }
}
function getHighlightedSuggestionIndex(suggestions) {
    const highlightedIndex = suggestions.findIndex(item => item.highlighted);
    return highlightedIndex === -1 ? 0 : highlightedIndex;
}
export { createDefaultTypeaheadReducerState, defaultSuggestion, getHighlightedSuggestionIndex, TypeaheadActionType, typeaheadReducer, };
